import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

import { Button } from "ds/Button";
import * as O from "src/organization/pages/billing/components/Overview/BillingOverview.styles";

export const OrganizationTitleWrapper = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 4fr 3fr;
`;

export const ManageUsersBtn = styled(Button)`
  font-size: 15px;
  font-weight: 600;
`;

export const UsersTable = styled(O.BaseBillingTable)`
  grid-template-columns: 1.2fr repeat(3, 1fr) 0.7fr;
`;

export const ProjectsTable = styled(O.BaseBillingTable)`
  grid-template-columns: max-content auto auto min-content;
  gap: 4px 16px;
`;

export const SupportTable = styled(O.BaseBillingTable)`
  grid-template-columns: max-content auto max-content;
`;

export const OtherTable = styled(O.BaseBillingTable)`
  grid-template-columns: 1.2fr repeat(3, 1fr) 0.7fr;
`;

export const SubtotalTable = styled(O.BaseBillingTable)`
  grid-template-columns: max-content auto max-content;
`;

export const Total = styled(Typography.Title)`
  grid-column: -3 / -1;
  text-align: right;
`;

export const AlertButton = styled(Button)`
  display: flex;
  gap: 8px;
  justify-self: end;
  padding: 0 16px 0 8px;
`;

export const EnterpriseMessageWrapper = styled.div`
  grid-column: 1 / -1;
`;

export const LoadingProject = styled(LoadingDs)`
  margin: 10px;
`;

export const LoadingAlertBtn = styled(LoadingDs)`
  margin: auto 20px auto auto;
`;
